function deckSlide(documentSlide) {
  return {
    id: documentSlide.id,
    image: documentSlide.file_url,
    status: documentSlide.status,
  }
}

function deckStatusProgress(deckData) {
  if (deckData.status === 'processing' && deckData.document_slides) {
    const imagesStatus = deckData.document_slides.map(
      (documentSlide) => documentSlide.status,
    )

    const imagesStatusSuccess = imagesStatus.filter(
      (status) => status === 'success',
    )

    return (imagesStatusSuccess.length / imagesStatus.length) * 100
  }

  if (deckData.status === 'success') {
    return 100
  }

  return 0
}

export function normalizeDeck(deckData) {
  return {
    file: {
      name: deckData.file_original_name,
      size: deckData.file_size,
      type: deckData.file_mimetype,
      url: deckData.file_url,
    },
    id: deckData.id,
    name: deckData.name,
    slides: (deckData.document_slides || []).map(deckSlide),
    status: deckData.status,
    statusProgress: deckStatusProgress(deckData),
  }
}

function recordingStatusProgress(deckData) {
  if (deckData.status === 'success') {
    return 100
  }

  return 0
}

export function normalizeRecording(recordingData) {
  return {
    deckTimestamps: Object.keys(recordingData.slides_timestamps).reduce(
      (accumulator, timestamp) => ({
        ...accumulator,
        [timestamp / 10]: recordingData.slides_timestamps[timestamp],
      }),
      {},
    ),
    file: {
      name: recordingData.file_original_name,
      size: recordingData.file_size,
      type: recordingData.file_mimetype,
      url: recordingData.file_url,
    },
    id: recordingData.id,
    media: recordingData.file_url,
    mediaFormat: recordingData.format,
    name: recordingData.name,
    status: recordingData.status,
    statusProgress: recordingStatusProgress(recordingData),
  }
}
